import {AuthorityPipe} from './pipes/common.pipe';
import {LoaderComponent} from './component/loader-component/loader.component';
import {AppInterceptor} from './interceptors/app-intercepter';
import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ErrorMessagesComponent} from './component/error-messages.component';
import {PasswordValidator, PhoneValidator, EmailValidator, IsNumberDirective, EqualValidator} from './directives/validator.directive';
import {BidiModule} from '@angular/cdk/bidi';
import {FlexLayoutModule} from '@angular/flex-layout';
import {SnackbarService} from './service/snackbar.service';
import {SharedService} from './service/shared.service';
import {LayoutModule} from '@angular/cdk/layout';
import {GooglePlacesDirective} from './directives/google-places.directive';
import {ConfirmAlertComponent} from './component/confirm-alert/confirm-alert.component';
import {environment} from 'src/environments/environment';
import {AgmCoreModule} from '@agm/core';
import {MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatMenuModule} from '@angular/material/menu';
import {MatCardModule} from '@angular/material/card';
import {MatRadioModule} from '@angular/material/radio';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTabsModule} from '@angular/material/tabs';
import {MatListModule} from '@angular/material/list';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSelectModule} from '@angular/material/select';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatSortModule} from '@angular/material/sort';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatStepperModule} from '@angular/material/stepper';
import {MatChipsModule} from '@angular/material/chips';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    HttpClientModule,
    MatInputModule,
    MatSidenavModule,
    MatCardModule,
    MatMenuModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatRadioModule,
    MatToolbarModule,
    MatTabsModule,
    MatListModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatProgressBarModule,
    FlexLayoutModule,
    BidiModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSortModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatTooltipModule,
    MatStepperModule,
    MatChipsModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    AgmCoreModule.forRoot({
      apiKey: environment.GOOGLE_MAPS_KEY,
      libraries: ['places']
    }),
    MatDialogModule,
    MatButtonModule

  ],
  declarations: [
    EmailValidator,
    PhoneValidator,
    PasswordValidator,
    EqualValidator,
    IsNumberDirective,
    ErrorMessagesComponent,
    LoaderComponent,
    AuthorityPipe,
    GooglePlacesDirective,
    ConfirmAlertComponent
  ],
  providers: [
    SharedService,
    SnackbarService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {hasBackdrop: true}
    }
  ],
  exports: [
    AgmCoreModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutModule,
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatInputModule,
    MatSidenavModule,
    MatCardModule,
    MatRadioModule,
    MatMenuModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatTabsModule,
    MatListModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatProgressBarModule,
    FlexLayoutModule,
    BidiModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSortModule,
    MatTooltipModule,
    MatTooltipModule,
    MatStepperModule,
    MatChipsModule,
    MatRadioModule,
    MatAutocompleteModule,
    EmailValidator,
    PhoneValidator,
    PasswordValidator,
    EqualValidator,
    IsNumberDirective,
    ErrorMessagesComponent,
    LoaderComponent,
    AuthorityPipe,
    MatProgressSpinnerModule,
    MatSliderModule,
    GooglePlacesDirective
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [
    ConfirmAlertComponent
  ]
})

export class SharedModule {
}
